/**
 * L'adresse de la fenêtre de l'assistant de saisie, et rien d'autre.
 *
 * Même parti que `fenetreDuPlanning.ts` : les deux bouts — le logo dans la fenêtre du planning,
 * et la fenêtre de l'assistant — se servent de ce module, pour qu'une adresse construite d'un
 * côté ne soit jamais décodée autrement de l'autre.
 *
 * *Décision de Chris, 23/10/2026 (docs/assistant-planning.md, D2 et D11) : le logo n'existe que
 * dans la fenêtre du planning ouverte depuis la contre-étude, et l'assistant s'ouvre dans une
 * fenêtre à part, qu'on peut mettre sur un second écran.*
 */

export const CHEMIN_FENETRE_ASSISTANT = "/assistant-planning";

/** Un nom par version : recliquer le logo ramène la fenêtre déjà ouverte au lieu d'en empiler une autre. */
export function nomFenetreAssistant(versionId: string): string {
  return `planif-assistant-${versionId}`;
}

export function adresseDeLAssistant(versionId: string): string {
  return `${CHEMIN_FENETRE_ASSISTANT}?${new URLSearchParams({ version: versionId }).toString()}`;
}
